module.exports = __webpack_public_path__ + "static/media/gh.2db7cdfa.svg";